import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { MessageResponse } from '../_models/responses';

interface Law {
  id?: number;
  title: string;
  description: string;
  propertyId: number;
}

@Injectable({ providedIn: 'root' })
export class LawService {
  constructor(private http: HttpClient) {}

  getLawsByPropertyId(propertyId: number) {
    return this.http.get<Law[]>(`${environment.apiUrl}/api/law/property/${propertyId}`);
  }

  getLaw(lawId: number) {
    return this.http.get<Law>(`${environment.apiUrl}/api/law/${lawId}`);
  }

  createLaw(request: any) {
    let header = new HttpHeaders();
    header = header.append('content-type', 'application/json');

    return this.http.post<MessageResponse>(`${environment.apiUrl}/api/law`, request, { headers: header });
  }

  updateLaw(lawId: number, request: any) {
    return this.http.put<MessageResponse>(`${environment.apiUrl}/api/law/${lawId}`, request);
  }

  deleteLaw(lawId: number) {
    return this.http.delete<MessageResponse>(`${environment.apiUrl}/api/law/${lawId}`);
  }
}
